import React, { useState } from 'react'

import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComment, faThumbtack, faTrash } from '@fortawesome/pro-solid-svg-icons'
import { isFunction, isObject } from 'lodash'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import TooltipIconButton from '../../antd/Buttons/TooltipIconButton'

const ScheduleActionsBar = ({ children, display = false, pinnedChatMessage, onChat, onDelete, onDisplay }) => {
  const t = useSelector(selectTranslate)

  const [show, setShow] = useState(false)

  const conditionnalClose = func => value => {
    if (isFunction(func)) {
      func()
    }

    handleShow(value)
  }

  const handleChat = () => conditionnalClose(onChat)(false)

  const handleDelete = () => conditionnalClose(onDelete)(false)

  const handleShow = value => {
    setShow(value)

    if (isFunction(onDisplay)) {
      onDisplay(value)
    }
  }

  return (
    <div
      onMouseEnter={() => handleShow(display)}
      onMouseLeave={() => handleShow(false)}
      style={{ position: 'relative' }}
    >
      {show && (
        <div className='schedule-actions-bar flex-row'>
          {isObject(pinnedChatMessage) && (
            <div className='pinned-message-preview'>
              <FontAwesomeIcon icon={faThumbtack} className='pinned-message-preview-icon' />
              <div className='pinned-message-preview-content'>{pinnedChatMessage.content}</div>
            </div>
          )}
          {isFunction(onDelete) && (
            <TooltipIconButton icon={faTrash} title={t('common.delete')} onClick={handleDelete} size='small' />
          )}
          <TooltipIconButton icon={faComment} title={t('common.chat')} onClick={handleChat} size='small' />
        </div>
      )}
      {children}
    </div>
  )
}

export default ScheduleActionsBar
